module.exports = __webpack_public_path__ + "img/7-3.aff9f335.jpg";